import React, { useState, useEffect } from "react";
import { LoginContext } from "context/Auth/LoginContext";
import useFetch from "Hooks/useFetch";
import Banner from "./Banner/Banner";
import Spinner from "Components/RequestHandler/Spinner";
import Slider from "Components/Slider";
import About from "./About/About";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();
  const { fetchData, isLoading } = useFetch();
  const [homeData, setHomeData] = useState(null);

  const fetchHomeData = async () => {
    const data = await fetchData("home");
    console.log(data, "from home");
    setHomeData(data?.data);
  };

  useEffect(() => {
    fetchHomeData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center mt-10 min-h-screen">
        <Spinner />
      </div>
    );
  }

  if (homeData) {
    return (
      <main>
        <Banner data={homeData?.banners} />

        {/* Newly Added Courses */}
        <Slider
          data={homeData?.newlyAddedCourses}
          title={t("courses.newlyAddedCourses")}
          subTitle={t("courses.mightBeInterested")}
          type="course"
        />

        <About data={homeData?.aboutHome} />

        {/* Recommended Courses */}
        <Slider
          data={homeData?.recommendedCourses}
          title={t("courses.mightBeInterested")}
          subTitle={t("courses.newlyAddedCourses")}
          type="course"
        />

        {/* Random Products - Hidden for now */}
        {/* <Slider
          isGrey={true}
          slideNumber={4}
          data={homeData?.randomProducts}
          title={t("products.moreProducts")}
          subTitle={t("products.recommendedBy")}
          type="product"
        /> */}
      </main>
    );
  }
};

export default Home;
